import { connect } from 'react-redux';

import PictureGalleryWrapper from './PictureGalleryWrapper';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import * as Actions from './actions';

export default connect(mapStateToProps, mapDispatchToProps)(PictureGalleryWrapper);

export { Actions };
